<template>
  <div>
    <a id='page-top'></a>
    <div id="kolorowe-karty-page" v-show="!isBuy">
      <div class="jumbo">

        <slot name="head">
          <div class="row">
            <div class="col">
              <span class="badge">OFERTA DLA BIZNESU</span>
              <h1>Dobrze policzone przejazdy</h1>
              <p class="mt-3 mb-3">
                Twoja firma pędzi do sukcesu. Sprawdź ofertę dla często podróżujących i korzystaj z pociągów PKP INTERCITY na terenie całego kraju. <br><br><b>Skorzystaj z Kolorowych Kart PKP INTERCITY już dziś!</b></p>
              <!-- <a href="#" @click="kalkulatorS" class="btn btn-primary">Oblicz ile zaoszczędzisz</a> -->
        <h2 >4 kroki do oszczędności</h2>
        <p >Wybierz kartę optymalną dla Twojej firmy. Skorzystaj z kalkulatora i sprawdź, ile możesz zaoszczędzić.
          <br>
          <b>Pamiętaj, że jeśli prowadzisz firmę możesz uwzględnić wydatek poniesiony na zakup karty w swoich rozliczeniach podatkowych<sup>1</sup>.</b></p>

            </div>
            <div class="col-7">
              
              <div style="width: 100%; padding-bottom: 59.06362545018007%; background-image: url(/images/karta-head.png?v=3); background-repeat: no-repeat;background-position: center;background-size: 100%"></div>
            </div>
            
          </div>      
        </slot>
      </div>
      
      <kolorowe-karty-kalkulator
        @calculated="calculated"
        :karty="karty"
        v-model="kalkulator"
        :v="$v"
        :zamow="zamow"
      />


      <section id="tresc">
        <slot name="tresc">
          <h2 class="text-center">Dlaczego Kolorowe Karty Intercity to dobry wybór?</h2>
          <div class="row">
            <div class="col-md-12">
              <div class="d-flex row">
                <div class="col-12 col-md-6  order-0 order-md-0">
                  <div class="bg-img" style='background-image:url(/images/kk_1.jpg)'></div>
                  
                </div>
                <div class="col-12 col-md-6 w-head order-1 order-md-1">
                  <h3 class="ico-1">Dbasz o finanse</h3>
                  <p>Oszczędzasz na kosztach podróży: wybierając Kolorowe Karty Intercity, zyskujesz nielimitowane przejazdy pociągami PKP INTERCITY oraz innych przewoźników: POLREGIO, PKP Szybka Kolej Miejska w Trójmieście, Warszawska Kolej Dojazdowa, Koleje Dolnośląskie.</p>
                </div>
                <div class="col-12 col-md-6 w-head  order-3  order-md-2">
                  <h3 class="ico-2">Masz chwilę dla siebie</h3>
                  <p>Nasze pociągi wyposażone są w gniazdka i&nbsp;Wi-Fi. Prowadź prezentacje, umawiaj spotkania biznesowe lub po prostu zrelaksuj się oglądając ulubione seriale.</p>
                </div>
                <div class="col-12 col-md-6  order-2  order-md-3"><div class="bg-img pull-right" style='background-image:url(/images/kk_2.jpg)'></div></div>
                <div class="col-12 col-md-6  order-4  order-md-4"><div class="bg-img" style='background-image:url(/images/kk_3.jpg)'></div></div>
                <div class="col-12 col-md-6 w-head  order-5  order-md-5">
                  <h3 class="ico-3">Zyskujesz czas</h3>
                  <p>Wybrane trasy pokonasz w czasie krótszym niż podróż samochodem. Po dotarciu na miejsce nie musisz korzystać z dodatkowego środka transportu i&nbsp;stać w korkach. Dworce zlokalizowane są w centrach miast.</p>
                </div>
                <div class="col-12 col-md-6 w-head  order-7  order-md-6">
                  <h3 class="ico-4">Troszczysz się o ekologię</h3>
                  <p>Nowoczesny tabor emituje ponad 3 razy mniej CO2 niż transport drogowy i&nbsp;ponad 8 razy mniej niż transport lotniczy. Wszystkie nowe pojazdy PKP INTERCITY są zbudowane z&nbsp; ekologicznych, podlegających recyklingowi materiałów.</p>
                </div>
                <div class="col-12 col-md-6  order-6  order-md-7"><div class="bg-img pull-right" style='background-image:url(/images/kk_4.jpg)'></div></div>

              </div>
              <div class="text-center d-none">
                <a href="#" @click="kalkulatorS" class="btn btn-primary"> {{$t('ic_kk_zamow')}}</a>
              </div>

            </div>
          </div>
        </slot>
      </section>
    
    </div>
    <div id="kolorowe-karty" class="ic-forms" v-if="!isSent && isBuy">
      <FormWrapper :validator="$v.form">

        <div >
          <div class="row">
            <div class="col-md-6 offset-md-1 col-12">
              <div class="karta" :class="form.card.waznosc">
              <div class="head">
                <p>
                  {{$t('ic_kk_karta_intercity')}}<br/>
                  <span >{{waznosc}}</span> <span >{{typ}}</span><br/>
                  <span>{{$t('ic_kk_klasa')}} {{form.card.klasa}}</span> - <span>{{discount}}</span>
                  <br/>
                </p>
              </div>  
                <div class="waznosc">
                  {{form.card.date_from}}
                </div>

              </div>
              
            </div>
            <div class="col-md-4 offset-md-1 col-12" id="karta">
              <h1>{{$t('ic_kk_twoja_karta')}}</h1>
              <p>{{$t('ic_kk_zloz_zamowienie')}}</p>
              <span class="cena">{{cena | formatNumber}} zł / {{cena_okres}}</span>

              <IcFormRowWrapper
                id="cardType"
                name="cardType"
                :aria="$t('ic_kk_pole_wymagane')"
                
                :labelWidth="0"
                :controlWidth="12"
              >
                <template>
                 <fieldset>
                  <legend class="sr-only">{{$t('ic_kk_rodzaj_zamawiajacego')}}</legend>
                  <IcRadioGroup
                    id="cardType"
                    v-model="form.cardType"
                    :options="cardTypeOptions"
                   
                    outerClass="radio-border"
                  ></IcRadioGroup>        
                  </fieldset>
                </template>
              </IcFormRowWrapper>


            </div>
          </div>
        </div>
        <div class="panel">
          <div class="panel-header">
            <h2  v-if="form.cardType == 'F'">{{$t('ic_kk_dane_firmy')}}</h2>
            <h2  v-if="form.cardType == 'P'">{{$t('ic_kk_twoje_dane')}}</h2>
          </div>

          <div class="row" id="company" v-if="form.cardType == 'F'">
            <div class="col-md-8 col-12">
                <IcFormRowWrapper
                  rowElement="IcFormRow"
                  id="company_company"
                  name="company.company"
                  :aria="$t('ic_kk_pole_wymagane')"
                  :label="$t('ic_kk_nazwa_firmy')"
                  :labelWidth="4"
                  :controlWidth="8"
                >
                  <template slot-scope="{validator}">
                    <IcInput id="company_company" v-model="form.company.company"  :placeholder="$t('ic_kk_nazwa_firmy_ph')"></IcInput>
                  </template>
                </IcFormRowWrapper>

            </div>
            <div class="col-md-4 col-12">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="vatid"
                name="company.vatid"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_nip')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="vatid" v-model="form.company.vatid"   :placeholder="$t('ic_kk_nip_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>              
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-6">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="contact_name"
                name="person.name"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_imie_nazwisko')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="contact_name" v-model="form.person.name"   :placeholder="$t('ic_kk_kontakt_imie_nazwisko_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>              
            </div>
            <div class="col-md-4 col-6">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="email"
                name="person.email"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_email')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="email" v-model="form.person.email"  :placeholder="$t('ic_kk_email_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>              
            </div>
            <div class="col-md-4 col-12">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="phone"
                name="person.phone"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_telefon')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="phone" v-model="form.person.phone"  :placeholder="$t('ic_kk_telefon_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>              
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 col-12">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="street"
                name="address.street"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_ulica')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="street" v-model="form.address.street"  :placeholder="$t('ic_kk_ulica_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>                  
            </div>
            <div class="col-md-2 col-6">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="streetNo"
                name="address.streetNo"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_ulica_nr_domu')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="streetNo" v-model="form.address.streetNo"  :placeholder="$t('ic_kk_ulica_nr_domu_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>                     
            </div>
            <div class="col-md-2 col-6">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="apartment"
                name="address.apartment"
                :label="$t('ic_kk_ulica_nr_lokalu')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="apartment" v-model="form.address.apartment"  :placeholder="$t('ic_kk_ulica_nr_lokalu_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>                    
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 col-6">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="city"
                name="address.city"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_miejscowosc')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="city" v-model="form.address.city"  :placeholder="$t('ic_kk_miejscowosc_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>              
            </div>
            <div class="col-md-4 col-6">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="zip"
                name="address.zip"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_kod_pocztowy')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="zip" v-model="form.address.zip"  :placeholder="$t('ic_kk_kod_pocztowy_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>              
            </div>
          </div>

          <div class="row">
            <div class="col-md-3 col-12">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="discount"
                name="card.discount"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_taryfa')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  
                  <IcSelect
                    id="discount"
                    :values="discountOptions"
                    v-model="form.card.discount"
                  />

                </template>
              </IcFormRowWrapper>              
            </div>

            <div class="col-md-3 col-6"  v-if="form.card.type == 'imienna'">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="owner"
                name="card.owner"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_kontakt_imie_nazwisko')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="owner" v-model="form.card.owner"  :placeholder="$t('ic_kk_kontakt_imie_nazwisko_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>              
            </div>


<!--             <div class="col-md-3  col-6"  v-if="form.card.type == 'imienna'">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="owner_document"
                name="card.owner_document"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('label_owner_document')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                
                  <IcInput id="owner_document" v-model="form.card.owner_document"  :placeholder="np. XYX 12345"></IcInput>
                
                </template>
              </IcFormRowWrapper>              
            </div> -->

            <div  class="col-md-3 col-12">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="date_from"
                name="card.date_from"
                :aria="$t('aria_required_date')"
                :label="$t('ic_kk_data_rozpoczecia_karty')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  
              <ic-date-picker
              id="date_from"
              v-model="form.card.date_from"
              title="Wybierz datę"
              aria="Strzałka w górę dół, następny poprzedni dzień."
              :minDate="minDate"
              :endDate="endDate"
            ></ic-date-picker>

                </template>
              </IcFormRowWrapper>              
            </div>

          </div>
          <div class="row">
            <div class="col-12">
                <IcCheckbox v-model="form.post_address" :val="1" id="post_address">{{$t('ic_kk_adres_do_korespondencji')}}</IcCheckbox>    
            </div>
          </div>
          <div class="row" v-if="form.post_address">
            <div class="col-8">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="street"
                name="address.street"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_ulica')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="street" v-model="form.post_street"  :placeholder="$t('ic_kk_ulica_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>                  
            </div>
            <div class="col-2">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="streetNo"
                name="address.streetNo"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_ulica_nr_domu')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="streetNo" v-model="form.post_street_no"  :placeholder="$t('ic_kk_ulica_nr_domu_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>                     
            </div>
            <div class="col-2">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="apartment"
                name="address.apartment"
                :label="$t('ic_kk_ulica_nr_lokalu')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="apartment" v-model="form.post_street_apartment"  :placeholder="$t('ic_kk_ulica_nr_lokalu_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>                    
            </div>
          </div>
          <div class="row"  v-if="form.post_address">
            <div class="col-8">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="city"
                name="address.city"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_miejscowosc')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="city" v-model="form.post_city"  :placeholder="$t('ic_kk_miejscowosc_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>              
            </div>
            <div class="col-4">
              <IcFormRowWrapper
                rowElement="IcFormRow"
                id="zip"
                name="address.zip"
                :aria="$t('ic_kk_pole_wymagane')"
                :label="$t('ic_kk_kod_pocztowy')"
                :labelWidth="4"
                :controlWidth="8"
              >
                <template slot-scope="{validator}">
                  <IcInput id="zip" v-model="form.post_zip"  :placeholder="$t('ic_kk_kod_pocztowy_ph')"></IcInput>
                </template>
              </IcFormRowWrapper>              
            </div>
          </div>          


        </div>
        <div class="panel">
          <div class="panel-header">
            <h2> {{$t('ic_kk_platnosc')}}</h2>
          </div>
          <div class="panel-body">
            <p>
              <small v-html="$t('ic_kk_uwaga')"> 
              </small>
            </p>
          </div>  

          <div class="boxes panel-body">
              <IcFormRowWrapper
                id="paymentType"
                name="paymentType"
                :aria="$t('ic_kk_pole_wymagane')"
                
                :labelWidth="0"
                :controlWidth="12"
              >
                <template>
                 <fieldset>
                  <legend class="sr-only"> {{$t('ic_kk_wybierz_rodzaj_platnosci')}} </legend>
                  <IcRadioGroup
                    id="paymentType"
                    v-model="form.paymentType"
                    :options="paymentTypeOptions"
                    outerClass="payment box"
                  ></IcRadioGroup>        
                </fieldset>
                </template>
              </IcFormRowWrapper>            

          </div>

        </div>


        <div class="panel">
          <div class="panel-header">
            <h2 v-html="$t('ic_kk_dostawa')"></h2>
          </div>

          <div class="boxes panel-body">
              <IcFormRowWrapper
                id="deliveryType"
                name="deliveryType"
                :aria="$t('ic_kk_pole_wymagane')"
                
                :labelWidth="0"
                :controlWidth="12"
              >
                <template >
                  <fieldset>
                  <legend class="sr-only"> {{$t('ic_kk_wybierz_metode_dostawy')}} </legend>
                    
                  <IcRadioGroup
                    id="deliveryType"
                    v-model="form.deliveryType"
                    :options="deliveryTypeOptions"
                    outerClass="delivery box"
                  ></IcRadioGroup>     
                  </fieldset>   
                </template>
              </IcFormRowWrapper>            

          </div>

        </div>

        <div class="cena">
          <span> {{$t('ic_kk_do_zaplaty')}}:</span>
          <b class="mt-5 mb-5">{{cena |formatNumber}} zł</b>
        </div>

        
        <div class="mb-5"></div>

        <IcFormAgreements v-model="form.akceptacja_dane" :text="false" :header="false" :modal="true" name="akceptacja_dane"
              :label="$t('ic_kk_akceptacja_1')" content="ic_kk_agreements">
        </IcFormAgreements>        
        
        <IcFormAgreements
          v-model="form.regulamin"
          :header="false"
          :label="$t('ic_kk_regulamin')"
          :text="false"
          name="regulamin"
        />

        <IcFormAgreements
          v-model="form.akceptacja_2"
          :header="false"
          :label="$t('ic_kk_akceptacja_2')"
          :text="false"
        />

        <IcFormAgreements
          v-model="form.akceptacja_1"
          :header="false"
          :label="$t('ic_kk_akceptacja_3')"
          :text="false"
        />


        <IcFormButtons
          @click="submit"
          :sending="isSending"
          :error="isError"
          :message="errorMessage"
          :zmienClick="zmienKarte"
        />
        

      </FormWrapper>
    </div>

    <section id="thankyou" v-if="isSent">

         <div class="alert alert-success _WithIcon" style="font-size: 18px;" role="alert">
        <span class="Text" style="font-size: 22px;"> {{$t('ic_kk_dziekujemy')}}</span></div>
      <p> {{$t('ic_kk_zamowienie_przyjete_1')}} <strong>{{sentData.formNumber}}</strong> {{$t('ic_kk_zamopwienie_przyjete_2')}}
      </p>
      {{$t('ic_kk_dane')}}
      <p>
      </p>
         
      

    </section>
  </div>

</template>

<script>
import Vue from "vue";
import icForm from "@/ic-common/mixins/icForm";

import IcFormRowHorizontal from "@/components/ic-common/form/helpers/FormRowHorizontal.vue";
import IcFormContactName from "@/components/ic/form/contact/Base/Name";
import IcFormContactMessage from "@/components/ic/form/contact/Base/Message";
import IcFormButtons from "@/components/ic/form/KoloroweKarty/Base/Buttons";
import IcInput from "@/components/ic-common/form/controls/Input";
import IcInputZip from "@/components/ic-common/form/controls/InputZip";
import { Address } from "@/components/ic/form/contact/Model/Address";

import IcSelect from "@/components/ic-common/form/controls/Select";
import IcFormContactEmail from "@/components/ic/form/contact/Base/Email";
import { Name } from "@/components/ic/form/contact/Model/Name";
import IcCheckbox from "@/components/ic-common/form/controls/Checkbox";

import IcTextarea from "@/components/ic-common/form/controls/Textarea";
import IcFormAgreements from "@/components/ic/form/contact/Base/Agreements";
import IcFormsSentBase from "@/components/ic/form/contact/Base/SentBase";
import IcRadioGroup from "@/components/ic-common/form/controls/RadioGroup";
import validations from "@/components/ic/form/KoloroweKarty/validation.js";
import IcDatePicker from "@/components/ic-common/form/controls/DatePicker";
import moment from "moment";

import KoloroweKartyKalkulator from "./KoloroweKartyKalkulator";

import get from "lodash/get";
import unset from "lodash/unset";
import forEach from "lodash/forEach";
import keys from "lodash/keys";
import VueScrollTo from 'vue-scrollto'

const _ = { get, forEach, keys, unset };

export default {
  name: "KoloroweKarty",
  props: {
    minDate: {
      type: String,
      default: moment().add(1,"day").format("YYYY-MM-DD")
    },
    endDate: {
      type: String,
      default: moment()
        .add(3, "months")
        .format("YYYY-MM-DD")
    }

  },
  mixins: [icForm],
  validations,
  watch: {
    "form.card.discount": function(newValue, oldValue) {
        if(newValue == 'U'){
            $("#discount").tooltip({title:"Ulga przysługuje osobom, którym pracodawca wykupił uprawnienia do ulgowych przejazdów zgodnie<br/>z <a target='_blank' href='https://www.intercity.pl/pl/dokumenty/Przepisy%20i%20taryfy/BIP/TP-IC_tekst_ujednolicony_zm_21_obowiazuje_od_29_11_2016.pdf#page=41'>§45 Taryfy przewozowej</a>.",html:true}).tooltip("toggle");
        }
     },
    "form.cardType": function(newValue, oldValue) {
        if(newValue == 'F'){
           // console.log("F");
          this.paymentTypeOptions[1].disabled = false;
          this.paymentTypeOptions[2].disabled = false;
          
            //this.paymentTypeOptions
        } else {
          this.paymentTypeOptions[1].disabled =true;
          this.paymentTypeOptions[2].disabled = true;
          this.form.paymentType = "transfer";
          //this.form.deliveryType = "courier";
        }
     },
    "form.paymentType": function(newValue, oldValue) {
      //console.log(this.form.cardType,newValue,this.`deliveryTypeOptions`);
        if(this.form.cardType == 'F' && (newValue == 'cash' || newValue == 'creditcard')){
           
            this.deliveryTypeOptions[1].disabled = true;
            this.form.deliveryType = 'in-person';

        } else {

          this.deliveryTypeOptions[1].disabled = false;
            this.deliveryTypeOptions[0].disabled = false;
         
        }
     }

  },  
  methods: {
    calculated(data){
      this.kalkulator = data;
    },

    zamow(karta,e){
      e.preventDefault();
      VueScrollTo.scrollTo(document.getElementById('page-top'), 300, {
            offset: -40
          });
      this.cenaPodstawowa = karta.cena;
      this.cena_okres = karta.okres;
      this.form.card.waznosc = karta.id;
      this.isBuy = true;
      this.form.card.type = this.kalkulator.type;
      this.form.card.klasa = this.kalkulator.klasa;
      this.form.card.discount = this.kalkulator.discount;
    }, 

    zmienKarte(e){
      e.preventDefault();
      setTimeout(function(){VueScrollTo.scrollTo(document.getElementById('info'));},300);
      this.isBuy = false;

    },
    kalkulatorS(e){
      e.preventDefault();
      VueScrollTo.scrollTo(document.getElementById('kalkulator'), 300, {
            offset: -40
      });
      this.isBuy = false;
    },

  },

  data() {
    return {
            karty: [
              {id: "zlota",    value: "zlota",     okres: "rok",      name:this.$t("ic_kk_ROCZNA"),    dni: 365,tygodni: 52,  typ:[{id: "bezimienna",name:this.$t("ic_kk_NA_OKAZICIELA"),klasa:{1:23000,2:15800}},{id: "imienna",name:this.$t("ic_kk_IMIENNA"),klasa:{1:15800,2:11000}}]},
              {id: "srebrna",  value: "srebrna",   okres: "pół roku", name:this.$t("ic_kk_POLROCZNA"), dni: 183,tygodni: 26,  typ:[{id: "bezimienna",name:this.$t("ic_kk_NA_OKAZICIELA"),klasa:{1:12000,2:8400}},{id: "imienna",name:this.$t("ic_kk_IMIENNA"),klasa:{1:8400,2:6000}}]},
              {id: "niebieska",value: "niebieska", okres: "kwartał",  name:this.$t("ic_kk_KWARTALNA"), dni: 91, tygodni: 13,  typ:[{id: "bezimienna",name:this.$t("ic_kk_NA_OKAZICIELA"),klasa:{1:7880,2:5630}},{id: "imienna",name:this.$t("ic_kk_IMIENNA"),klasa:{1:5630,2:4130}}]},
              {id: "zielona",  value: "zielona",   okres: "miesiąc",  name:this.$t("ic_kk_MIESIECZNA"),dni: 30, tygodni: 4.3, typ:[{id: "bezimienna",name:this.$t("ic_kk_NA_OKAZICIELA"),klasa:{1:3940,2:2810}},{id: "imienna",name:this.$t("ic_kk_IMIENNA"),klasa:{1:2810,2:2060}}]}
             ],
      isBuy:false,
      cenaPodstawowa: "23000",
      cena_okres: "rok",
      cardTypeOptions: [{ id: 'F', name: this.$t("ic_kk_rodzaj_firma") }, { id: 'P', name: this.$t("ic_kk_rodzaj_osoba_prywatna") }],
      paymentTypeOptions: [{  id: 'transfer',  name: this.$t('ic_kk_payment_transfer'),   icon:"box-icon przelew" }, { id: 'cash', name: this.$t('ic_kk_platnosc_gotowka'), icon:"box-icon gotowka",disabled:false }, { id: 'creditcard', name: this.$t('ic_kk_platnosc_karta'), icon:"box-icon karta",disabled: false }],
      deliveryTypeOptions: [{ id: 'in-person', name: this.$t('ic_kk_delivery_in-person'), icon:"cok", disabled:false }, {  id: 'courier', name: this.$t('ic_kk_dostawa_kurier'), icon:"courier", disabled:false }],



      waznoscOptions: [
            {id: "zlota",name:this.$t("ic_kk_ROCZNA"), value: "zlota", okres: "rok"},
            {id: "srebrna",name:this.$t("ic_kk_POLROCZNA"), value: "srebrna", okres: "pół roku"},
            {id: "niebieska",name:this.$t("ic_kk_KWARTALNA"), value: "niebieska", okres: "kwartał"},
            {id: "zielona",name:this.$t("ic_kk_MIESIECZNA"), value: "zielona", okres: "miesiąc"},
      ],
      typeOptions: [
          {id: "bezimienna", value:  "bezimienna",name:this.$t("ic_kk_NA_OKAZICIELA")},
          {id: "imienna",    value:  "imienna",   name:this.$t("ic_kk_IMIENNA")}
      ],
      discountOptions: [
        {id: "N", value: "N", name:this.$t("ic_kk_OPLATA_NORMALNA")},
        {id: "U", value: "U", name:this.$t("ic_kk_OPLATA_ULGOWA_50%")}
        ],
      klasaOptions: [
          {id: 1,value: 1, name:this.$t("ic_kk_KLASA_I")},
          {id: 2,value: 2, name:this.$t("ic_kk_KLASA_II")}
        ],
      kalkulator: {
        ilosc:10,
        waznosc: "",
        klasa: "",
        type: "",
        isCalculated:false,
        isTouched:false,
        wybrana: "",
        discount: "N",
        pozostale: []
      },
      form: {
        type: "KoloroweKarty",
        
        card:{
          waznosc:"",
          type:"",
          klasa: 2,
          discount: "N",
          owner:"",
          owner_document: "",
          count: 1,
          date_from: "",

        },
        company: {
          company: "",
          vatid: "",
        },
        address:{
          street: "",
          streetNo: "",
          apartment:"",
          zip: "",
          city: ""
        },        
        post_address: 0,
        post_street: "",
        post_street_no: "",
        post_street_apartment:"",
        post_zip: "",
        post_city: "",

        person:{
          name:"",
          email: "",  
          phone: ""
        },

        cardType: "F",
        paymentType: "transfer",
        deliveryType: "courier",
      
        akceptacja_2: "",
        akceptacja_1: "",
        akceptacja_dane: "",
        regulamin: "",
        agreement: "",
        recaptcha: ""
      },
      sentData: {},
      isSent: false,
      regulationsUrl: this.$t("Wyrażam zgodę na przesyłanie do mnie informacji handlowej drogą elektroniczną na podany adres e-mail."),

      // sizes: [
      //   { value: "s", name: "S" },
      //   { value: "m", name: "M" },
      //   { value: "l", name: "L" },
      //   { value: "xl", name: "XL" }
      // ],
      formUrl: "/ax26hrxl857-a/components/ickolorowekarty/connector.php?action=store"
    };
  },
  computed:{
    today: function(){
      var today  = new Date();
      var options = { weekday: 'long',  month: 'long', day: 'numeric' };
      return today.toLocaleDateString("pl-PL", options)[0].toUpperCase() + today.toLocaleDateString("pl-PL", options).substring(1)+", ";
    },
    cena: function(){
      
      return this.form.card.discount == 'N'?this.cenaPodstawowa:this.cenaPodstawowa/2;
    },
    k_waznosc: function(){
      var w = this.kalkulator.waznosc;
      var o =  this.waznoscOptions.filter(function(e){
          return e.id == w;
      });
      return o.length?o[0].name:"";
    },
    k_typ: function(){
      var w = this.kalkulator.type;
      var o =  this.typeOptions.filter(function(e){
          return e.id == w;
      });
      return o.length?o[0].name:"";
    },
    k_discount: function(){
      var w = this.kalkulator.discount;
      var o =  this.discountOptions.filter(function(e){
          return e.id == w;
      });
      return o.length?o[0].name:"";
    },

    waznosc: function(){
      var w = this.form.card.waznosc;
      var o =  this.waznoscOptions.filter(function(e){
          return e.id == w;
      });
      return o.length?o[0].name:"";
    },
    typ: function(){
      var w = this.form.card.type;
      var o =  this.typeOptions.filter(function(e){
          return e.id == w;
      });
      return o.length?o[0].name:"";
    },
    discount: function(){
      var w = this.form.card.discount;
      var o =  this.discountOptions.filter(function(e){
          return e.id == w;
      });
      return o.length?o[0].name:"";
    }
  },
  components: {
    IcFormRowHorizontal,
    IcFormContactName,
    IcFormContactEmail,
    IcTextarea,
    IcFormButtons,
    IcDatePicker,
    IcSelect,
    IcFormAgreements,
    IcFormsSentBase,
    IcInput,
    IcRadioGroup,
    KoloroweKartyKalkulator,
    IcCheckbox

  },
filters: {
  formatNumber: function (value) {
    if (!value) return ''

    var decimals = 0, dec_point = "," , thousands_sep = " ", number = value;

    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
   
//    return new Intl.NumberFormat().format(value);
  }
}

};
</script>


<style lang="scss">
// Small tablets and large smartphones (landscape view)
$screen-xxsm-min: 300px;

$screen-xsm-min: 375px;

$screen-sm-min: 576px;

// Small tablets (portrait view)
$screen-md-min: 768px;

// Tablets and small desktops
$screen-lg-min: 992px;

// Large tablets and desktops
$screen-xl-min: 1200px;
// Small devices
@mixin sm {
   @media (min-width: #{$screen-sm-min}) {
       @content;
   }
}

@mixin maxsm {
   @media (max-width: #{$screen-sm-min}) {
       @content;
   }
}
@mixin maxxsm {
   @media (max-width: #{$screen-xsm-min}) {
       @content;
   }
}
@mixin maxxxsm {
   @media (max-width: #{$screen-xxsm-min}) {
       @content;
   }
}

// Medium devices
@mixin md {
   @media (min-width: #{$screen-md-min}) {
       @content;
   }
}

// Large devices
@mixin lg {
   @media (min-width: #{$screen-lg-min}) {
       @content;
   }
}

// Extra large devices
@mixin xl {
   @media (min-width: #{$screen-xl-min}) {
       @content;
   }
}
.ic-forms {
  h3 {
    margin: 30px 0;
  }
  .has-error {
    label, p {
      color: #ed1c24;
      font-size:14px;
    }
  }
}
#high-contrast{
  #kolorowe-karty,#kolorowe-karty-page {
      color:#fff !important;
      h2, h1, h3, .wariant .okres, .wariant .cena, #karta  {
        color:#fff !important;
  
        .radio-border {
           border-color: #fff;
        &.selected {
          border-color: #fff200;
        }

        }

      }
    .box{
      border-color: #fff;
      &.selected {
        border-color: #fff200;
      }
    }
    .btn-primary, .btn-success {
      background-color: #3a3a3a;
      border: 1px #ccc solid;
      color: #fff200;
    }
    #kalkulator{
      .form{
        h3{
          color:#000 !important;
        }
       .multiselect__select::before {
          color:#fff;
          border-color: #fff transparent transparent transparent;
        }
      }
      .panel {
        .panel-head {
          h3 {
          color:#000 !important;    
          }
        }        
      }
    }
    .badge{
      background: #3a3a3a;
    }  

    .karta {
      color:#000 !important;
    }
    .panel-header{
      h2 {
        color:#000 !important;
      }

    }
    #tresc {
      .w-head{
        h3{
          color:#000 !important;
        }
      }
    }

  }  
}
#kolorowe-karty-page, #kolorowe-karty {
  #welcome {
      font-weight:bold;
      font-size: 18px;
      line-height: 33px;
      color: #333333;    
  }
  .bg-img{
      padding-bottom: 70%;
      width: 100%;
      max-width: 377px;
      background-color: transparent;
      background-repeat: no-repeat;
  }
  .btn-primary.active, .btn-primary:active, .btn-primary:focus, .btn-primary:hover, .open > .btn-primary.dropdown-toggle {
    opacity:1;
  }
  .badge {
    border-radius: 0;
    color: #fff;
    background: #f68321;
    padding: 4px 9px;
  }
  b{
    
  }
color: #00002f !important;
font-weight: light;
font-size: 18px;
line-height: 25px;
  

  #karta {
    color: #002d59;
    h1 {
      font-weight:bold;
      font-size: 40px;
      margin:0;
      line-height: 40px;
      margin-bottom:10px;
    }
    p {
      font-size:18px;
      font-weight:light;
    }
    span.cena {
      font-weight:bold;
      font-size:26px;
    }
    .radio-border {
font-size: 20px;
border: 2px solid #002d59;
border-radius: 4px;
margin-top: 38px;
padding-left: 20px;
    }
    .radio-border.selected {
      border-color: #f58220;
    }
    .radio-custom-btn {
      top:14px;
    }
    .karta{
      font-weight:bold !important;
      color:#FFF;
      .head {
        font-size: 25px;
        span {
          font-size:17px;
        }
      }
      .waznosc {
        font-size:14px;
      }
    }
  }
    .checkbox-custom label {font-size:14px;}
    .panel-header {
      h2{
          background: transparent url(/images/belka.png?v=3) no-repeat top left;
          height: 68px;
          color: #fff;
          font-size: 16px;
          font-weight:bold !important;
          padding-left: 121px;
          
          line-height: 26px;       
          @include lg {
            margin-left: -90px;
            margin-bottom: -20px;
          }
      }
    }
    label.control-label {
      font-size: 16px;
      font-weight:bold !important;
    }

    .box {
      margin:auto;
      margin-bottom:20px;
      
      &.selected {
         border-color: #f58220;
      }
      
      @include lg {
        float:left;  
        margin-right: 16px;
      }


      border:2px solid #002d59;
      border-radius:8px;
      
      width:255px;
      height:200px;
      
      justify-content: center !important;
      display:flex;
      align-items: center !important;
      .radio-custom{
        padding:0;margin:0;display:block;
      }
      label {
        display:flex;
        flex-direction: column !important;
        justify-content: center !important;
        text-align: center;
        padding: 10px 40px;
        span.radio-custom-btn {
          order:3;
          position: relative;
          margin:auto;
          left:0px;
        }
        .option-text{
          order:2;
          font-size:20px;
          margin-bottom:15px;
        }
        .box-icon {
          order:1;
        }
      }

      .box-icon{
        &.przelew, &.gotowka,&.karta {
          width: 110px;
          height: 90px;
          background-position: center;
          background-repeat: no-repeat;
          margin:auto;
        }
        &.przelew{background-image:url(/images/przelew.png?v=3)}
        &.gotowka{background-image:url(/images/gotowka.png?v=3)}
        &.karta {background-image:url(/images/karta.png?v=3)}
      }
    }
    .panel {
      border:none;
      margin-bottom: 60px;
      .panel-body {
          
        @include lg {
          padding:0;
        }
      }
    }
    .btn-primary {
            background: #f68321;border-radius: 25px;font-size: 20px;font-weight: bold !important;padding: 10px 20px;height: auto;border: none;    
    }
    .btn-success {
      border-radius: 25px;font-size: 20px;font-weight: bold !important;padding: 10px 20px;height: auto;
    }
    .cena{
      font-size: 24px;

      b{
        font-weight:bold !important;
        display: block;
        font-size:34px;
      }
    }
    .karta {
      position: relative;
      width:100%;
      padding-bottom: 62.79527559055118%; 
      background-size: contain;
      background-repeat: no-repeat;
      background-position: top left;     
      .head {
        position:absolute;
        color:#fff;
        top: 33%;
        left: 3%;        
        span {font-size:14px;font-weight:bold !important;
        }
        p {
          margin:0;padding:0;line-height:18px;font-weight:bold !important;
          font-size:20px;
        }
      }
      &.zlota{
        background-image: url(/images/karta-zlota.png?v=3);
      }
      &.srebrna{
        background-image: url(/images/karta-srebrna.png?v=3);
      }
      &.zielona{
        background-image: url(/images/karta-zielona.png?v=3);
      }
      &.niebieska{
        background-image: url(/images/karta-niebieska.png?v=3);
      }
      .waznosc{
        position:absolute;
        font-size: 11px;
        bottom: 13%;
        left: 12%;
        font-weight:bold !important;
        color:#fff;
      }
    }
    .wariant{
      min-width: 80%;
      max-width: 80%;
      margin:auto;
      // Large devices
    @include lg {
      min-width: 25%;
      max-width: 30%;
    }

      .light-blue{
        color:#0071bd;
        font-weight:bold !important;
        font-size: 18px;
        margin:20px 0 10px;
      }
      .okres, .cena {
        color:#2a3c3d;
        line-height:40.5px;
        font-weight:bold !important;
      }
      .okres{
          margin-bottom: 10px;
        font-size: 38.6px;
        
      }
      .cena{
        font-size:18px;
        line-height: 24px;
        span {
          font-size: 30px;
          margin:10px 0;
          display: block;
        }
      }
      .btn {
        display: inline-block;
      }
      .head {
        p{
          line-height: 10px;
        }
        font-size: 13px;
        span{
          font-size: 10px;
        }
      }
    }
    #tresc {
      margin-top: 6rem;
      h2{
        margin-bottom: 3rem;margin-top: -50px!important;
      }
      h3 {
          font-size:24px;
          color:#fff;
          height: 99px;
          font-weight:bold !important;
          line-height: 36px;
          padding-left: 179px;
          margin-left: -39px;
          padding-top:0;
          margin-top:0;
          @include maxsm {
            font-size:18px;
            padding-left:170px;
            margin-left: -46px;
          }
          @include maxxsm {
            font-size:16px;
            padding-left:170px;
            margin-left: -46px;
          }
          @include maxxxsm {
            font-size:14px;
            padding-left:170px;
            margin-left: -46px;
          }
      }
      .ico-1 {
        background: transparent url(/images/info_belka_1.png?v=3) no-repeat top left;
      }
      .ico-2 {
        background: transparent url(/images/info_belka_2.png?v=3) no-repeat top left;
      }
      .ico-3 {
        background: transparent url(/images/info_belka_3.png?v=3) no-repeat top left;
      }
      .ico-4 {
        background: transparent url(/images/info_belka_4.png?v=3) no-repeat top left;
      }
      .col-12{
        margin-bottom:60px;
      }
      .w-head {
          
        p{
padding-left: 80px;
margin-top: -55px;
font-size: 18px;
        }
      }
    }

}
#kolorowe-karty {
  .ic-form__agreements{font-size:16px;}
}
.img-fluid {
    max-width: 100%;
    height: auto;
}

#kolorowe-karty  .checkbox.checkbox-custom > label > input {margin-right:10px

}

#kolorowe-karty .checkbox.checkbox-custom > label > span {font-size: 16px;color:#002d59;}


</style>
